import React, { useRef, useState } from 'react';
import { useHistory } from "react-router-dom";
import './subscriptionForm.css';
import { useDispatch, useSelector } from "react-redux";
import { subscriptionFormAction,
    userFormAction,
    selectAction } from "../../redux/rootReducer";
import {
    changeUnlimSubscriptionSagaAction,
    getUsersForSubscriptionSagaAction,
    updateSubscriptionSagaAction
} from "../../redux/sagaActions";
import TextareaAutosize from "react-textarea-autosize";
import Payment from "../Payment/Payment";
import { SELECT_INITIAL, USER_FORM_INITIAL } from "../../redux/initialStateConstant";
import Select from "../Select/Select";
import CalendarOffline from "../CalendarOffline/CalendarOffline";

const SubscriptionForm = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const subscriptionForm = useSelector(state => state.subscriptionForm);
    const subscription_coaches = useSelector(state => state.subscription_coaches);
    const subscription_types = useSelector(state => state.subscription_types);
    const subscription_constraints = useSelector(state => state.subscription_constraints);

    // Состояние календаря
    const [openCalendar, setOpenCalendar] = useState(false);

    // Таймер для отсрочки запроса посетителей на сервере
    const timer = useRef(0);

    const getUsers = text => {

        if (timer.current) clearTimeout(timer.current);

        if (!text.trim()) {
            dispatch(subscriptionFormAction({
                ...subscriptionForm,
                user: { id: '', name: '' },
                users: [],
                userInput: ''
            }));
            return false;
        }

        // Делаем задержку для набора текста
        timer.current = setTimeout(() => {
            dispatch(getUsersForSubscriptionSagaAction({ text, type: 'edit' }));
        }, 500);
    };

    if (!subscriptionForm.open) return false;

    return (
        <div className="form">
            <div className="form__scrollable">
                <div className="form__content">
                    <div className="form__header">
                        <div className="form__title">{ subscriptionForm.title }</div>
                        <i className="form__close" onClick={ () => dispatch(subscriptionFormAction({ ...subscriptionForm, open: false })) } />
                    </div>
                    <div className="form__field">
                        <div className="input__caption input__caption--required">Посетитель (имя, почта или телефон)</div>
                        <div className="dropdown">
                            {
                                subscriptionForm.expire_date
                                ?
                                    <div className="input input--inactive">{ subscriptionForm.userInput || subscriptionForm.user?.name || '' }</div>
                                :
                                    <input type="text" className="input"
                                           value={
                                               subscriptionForm.userInput ||
                                               subscriptionForm.user?.name || ''
                                           }
                                           onInput={ event => {
                                               dispatch(subscriptionFormAction({
                                                   ...subscriptionForm,
                                                   userInput: event.target.value,
                                                   user: { id: '', name: '' }
                                               }));
                                               // Получение с сервера списка всех пользователей, с совпадением по email или телефону
                                               getUsers(event.target.value);
                                           } }
                                    />
                            }
                            <div className={ `dropdown__items ${ subscriptionForm.userInput ? 'dropdown__items--open' : '' }` }>
                                {
                                    subscriptionForm.users?.length
                                        ? subscriptionForm.users.map(elem => {
                                            return (
                                                <div className="dropdown__item" key={ elem.id }
                                                     onClick={ () => {
                                                         dispatch(subscriptionFormAction({
                                                             ...subscriptionForm,
                                                             user: elem,
                                                             userInput: ''
                                                         }));
                                                     } }
                                                >{ elem.name }</div>
                                            );
                                        })
                                        : <div className="dropdown__item"
                                               onClick={ () => {
                                                   // Переходим на страницу с посетителями
                                                   history.push('/fitness/users');
                                                   // Закрываем форму добавления абонемента
                                                   dispatch(subscriptionFormAction({
                                                       ...subscriptionForm,
                                                       open: false
                                                   }));
                                                   // Открываем форму добавления посетителя
                                                   dispatch(userFormAction({
                                                       ...USER_FORM_INITIAL,
                                                       open: true,
                                                       title: 'Новый посетитель'
                                                   }));
                                               } }
                                        >{ `Добавить посетителя` }</div>
                                }
                            </div>
                        </div>
                    </div>
                    <div className="form__field">
                        <div className="input__caption">Дата активации</div>
                        <div className={ `input input--relative ${ subscriptionForm.activation_date === 'Не активирован' ? 'input--inactive' : '' }` } onClick={ event => {
                            event.preventDefault();
                            event.stopPropagation();
                            setOpenCalendar(true);
                        } }>
                            {
                                subscriptionForm.activation_date
                                    ?
                                    new Date(subscriptionForm.activation_date).toLocaleDateString('ru-Ru')
                                    :   'Не активирован'
                            }
                        </div>
                        <CalendarOffline
                            handler={ date => {
                                dispatch(subscriptionFormAction({
                                    ...subscriptionForm,
                                    activation_date: date
                                }));

                                setOpenCalendar(false);
                            } }
                            open={ openCalendar }
                            close={ () => setOpenCalendar(false) }
                        />
                    </div>
                    <div className="form__field">
                        <div className="input__caption">Срок действия</div>
                        <div className="input input--inactive">{ subscriptionForm.expire_date }</div>
                    </div>
                    <div className="form__field">
                        <div className="input__caption">Количество посещений</div>
                        {
                            subscriptionForm.unlim === '1'
                            ?
                                <>
                                    <div className="input input--inactive">{ subscriptionForm.times }</div>
                                    <div className="form__unlim"
                                         onClick={ () => dispatch(changeUnlimSubscriptionSagaAction({
                                             subscription_id: subscriptionForm.id
                                         })) }
                                    >Убрать безлимит</div>
                                </>
                            :
                                <>
                                    <input
                                        className="input"
                                        type={ 'number' }
                                        value={ subscriptionForm.times }
                                        onInput={ event => dispatch(subscriptionFormAction({
                                            ...subscriptionForm,
                                            times: event.target.value
                                        })) }
                                    />
                                    <div className="form__unlim"
                                        onClick={ () => dispatch(changeUnlimSubscriptionSagaAction({
                                            subscription_id: subscriptionForm.id
                                        })) }
                                    >Сделать безлимитом</div>
                                </>
                        }
                    </div>
                    {
                        subscription_types.length
                        ?
                            <div className="form__field">
                                <div className="input__caption">Тип занятий</div>
                                <Select
                                    current={ subscriptionForm.type?.name }
                                    type={ 'type' }
                                    options={ subscription_types.filter(el => el.hide_subscription !== '1') }
                                    handler={ elem => {
                                        dispatch(subscriptionFormAction({
                                            ...subscriptionForm,
                                            type: elem
                                        }));
                                        dispatch(selectAction(SELECT_INITIAL));
                                    } }
                                    smart={ true }
                                />
                            </div>
                        : false
                    }
                    {
                        subscription_coaches.length > 1
                            ?
                            <div className="form__field">
                                <div className="input__caption">Тренер</div>
                                <Select
                                    current={ subscriptionForm.coach?.name }
                                    type={ 'coaches' }
                                    options={ subscription_coaches }
                                    handler={ elem => {
                                        dispatch(subscriptionFormAction({
                                            ...subscriptionForm,
                                            coach: elem
                                        }));
                                        dispatch(selectAction(SELECT_INITIAL));
                                    } }
                                    smart={ true }
                                />
                            </div>
                            : false
                    }
                    {
                        subscription_constraints.length
                        ?
                            <div className="form__field">
                                <div className="input__caption">Ограничения</div>
                                <Select
                                    current={ subscriptionForm.time_constraint?.name || 'Нет ограничений' }
                                    type={ 'constraints' }
                                    options={ subscription_constraints }
                                    handler={ elem => {
                                        dispatch(subscriptionFormAction({
                                            ...subscriptionForm,
                                            time_constraint: elem
                                        }));
                                        dispatch(selectAction(SELECT_INITIAL));
                                    } }
                                />
                            </div>
                        : false
                    }
                    <div className="form__field">
                        <div className="input__caption">Примечание</div>
                        <TextareaAutosize
                            className="input input--textarea"
                            value={ subscriptionForm.note }
                            onInput={ event => dispatch(subscriptionFormAction({
                                ...subscriptionForm,
                                note: event.target.value
                            })) }
                        />
                    </div>
                    <div className="form__field">
                        <div className="input__caption">Стоимость</div>
                        <div className="input input--inactive">{ subscriptionForm.old_cost }</div>
                    </div>
                    <Payment
                        payment={ subscriptionForm.payment }
                        totalSum={ subscriptionForm.total_sum }
                        discountValue={ subscriptionForm.discount }
                        handler={ ({ payment, discount, total_sum }) => dispatch(subscriptionFormAction({
                            ...subscriptionForm,
                            payment,
                            discount,
                            total_sum
                        })) }
                    />
                    <div className="form__field">
                        <div className="button"
                            onClick={ () => {
                                let formattedPayments = [];
                                // Фильтруем и форматируем платежи
                                subscriptionForm.payment.forEach(el => {
                                    if (el.cost) {
                                        formattedPayments.push({ cost: el.cost, payment_method: el.payment_method.id });
                                    }
                                });

                                dispatch(updateSubscriptionSagaAction({
                                    id: subscriptionForm.id,
                                    user: subscriptionForm.user.id,
                                    times: subscriptionForm.times,
                                    coach: subscriptionForm.coach.id,
                                    type: subscriptionForm.type.id,
                                    constraint: subscriptionForm.time_constraint.id,
                                    note: subscriptionForm.note,
                                    payment: JSON.stringify(formattedPayments),
                                    discount: subscriptionForm.discount.id,
                                    activation_date: subscriptionForm.activation_date
                                }));
                            } }
                        >Сохранить</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SubscriptionForm;